'use strict';

function NgTrim(constantSettings) {
    return {
        require: '^ngModel',
        priority: constantSettings.directivePriority,
        link: function(scope, iElem, iAttrs, ngModel) {
            (iAttrs.ngTrim === 'false') && ngModel.$parsers.unshift(function() {
                return iElem.val();
            });
        }
    };
}

NgTrim.$inject = ['constantSettings'];
export default NgTrim;


// WEBPACK FOOTER //
// ./src/app/scripts/directives/ngTrimDirective.js